import React from 'react';
import { SectionReveal } from '../components/SectionReveal';
export function RealitySection() {
  return <section className="relative w-full bg-brand-mid py-20 md:py-28 overflow-hidden" data-id="element-212">
      {/* Accent line */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-blue-500/30 to-transparent" data-id="element-213" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center" data-id="element-214">
        <SectionReveal data-id="element-215">
          <p className="text-4xl mb-4" data-id="element-216">⚡</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white mb-8 uppercase leading-tight tracking-[-0.02em]" data-id="element-217">
            La mayoría de las personas no tiene un problema de ingresos…
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.15} data-id="element-218">
          <div className="bg-blue-500/10 border-2 border-blue-500/30 rounded-xl p-6 md:p-8 mb-8 inline-block" data-id="element-219">
            <p className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-blue-400 m-0" data-id="element-220">
              👉 Tiene un problema de gastos invisibles.
            </p>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.25} data-id="element-221">
          <p className="text-xl sm:text-2xl text-gray-300 font-body" data-id="element-222">
            Y la luz es uno de los más grandes.
          </p>
        </SectionReveal>
      </div>
    </section>;
}